<template>
	<div
		class="w-full fixed bottom-5 px-4 z-40 cookiesNoticePopupComponent"
		v-if="shouldShowCookiePopup">
		<div class="h-30 bg-white p-4 mx-auto rounded-lg flex max-sm:flex-col gap-4 justify-between">
			<p>{{ $t("cookiesNotice") }}</p>

			<div class="flex gap-4 justify-evenly place-items-center">
				<FormBtn
					type="button"
					preset="back"
					:rounded="false"
					@click="decline">
					{{ $t("decline") }}
				</FormBtn>
				<FormBtn
					type="button"
					preset="primary"
					:rounded="false"
					@click="accept">
					{{ $t("accept") }}
				</FormBtn>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { useNuxtApp } from "nuxt/app"

	const { $cookiesConsent } = useNuxtApp()
	const shouldShowCookiePopup = ref(false)

	onMounted(() => {
		shouldShowCookiePopup.value = !$cookiesConsent.$hasUserDecided()
		$cookiesConsent.$init()
	})

	const accept = () => {
		$cookiesConsent.$acceptCookies()
		shouldShowCookiePopup.value = false
	}

	const decline = () => {
		$cookiesConsent.$declineCookies()
		shouldShowCookiePopup.value = false
	}
</script>
